import { master, setParamLocale } from '$stores/master';
import { get } from 'svelte/store';

export const load = async ({ params }) => {
    await setParamLocale(params.lang);
    return {
        master: get(master),
    };
};

export const trailingSlash = 'always';
